import { Button, Form, Modal, Radio } from 'antd';
import { types, utils } from 'utils';


interface Props {
    open: boolean;

    onClose: () => void;
    onChange: (e: types.ComparisonOption) => void;
}
const ComparisonFilter = ({ open, onClose, onChange }: Props) => {

    const [form] = Form.useForm();

    const submit = (v: any) => {
        onChange(v);
        close();
    }
    const close = () => {
        onClose();
        form.resetFields();
    }

    return (
        <Modal open={open} centered width={500} title="Comparison" footer={null} maskClosable={false} closable onCancel={close}>
            <Form form={form} layout="vertical" autoComplete="off" className="mt-6 text-center" onFinish={submit}>
                <Form.Item name="type" initialValue="" rules={[utils.requiredInput]}>
                    <Radio.Group optionType="button" buttonStyle="solid" options={utils.data.views.map(year => {
                        return { value: year, label: year }
                    })} />
                </Form.Item>

                <Form.Item name={['year', 0]} initialValue="" rules={[utils.requiredInput]}>
                    <Radio.Group optionType="button" buttonStyle="solid" size="small" options={utils.data.filterYears.map(year => {
                        return { value: year, label: year }
                    })} />
                </Form.Item>

                <Form.Item name={['year', 1]} initialValue="" rules={[utils.requiredInput]}>
                    <Radio.Group optionType="button" buttonStyle="solid" size="small" options={utils.data.filterYears.map(year => {
                        return { value: year, label: year }
                    })} />
                </Form.Item>

                <div className="my-6 border-b" />
                <Button type="primary" htmlType="submit" size="large" block>Compare</Button>
            </Form>
        </Modal>
    );
}

export default ComparisonFilter;